import React, { useState } from 'react'
import Layout from '../../../components/layouts'
import Banner from '../../../components/features/Banner'
import SEO from '../../../components/common/SEO';
import ReactWOW from 'react-wow'
import FeatureCards from "../../../components/features/FeatureCards"

export const query = graphql`
  query ActionItems {
    site {
      siteMetadata {
        defaultTitle: title
        titleTemplate
        defaultDescription: description
        siteUrl: url
        defaultImage: image
        twitterUsername
      }
    }
  }
`

export default ({ data }) => {
  const [toggler, setToggler] = useState(false)
  const lightboxProps = {
    toggler: toggler,
    setToggler: setToggler,
    sources: ["https://www.youtube.com/watch?v=xE2yXvWB038"],
  }

  const bannerProps = {
    title: 'Action Items',
    subtitle: `Team members across your organization spend countless hours a week assessing and reporting on all sort of initiatives like Inspections, Incident Reporting, Hazard IDs, and all sorts of other forms. Inevitably, they drum up deficiencies - Gotchas that, if left unattended, could lead to further incidents. Those deficiencies need to be handled, and you need to know the where, why, when, who, and how.`,
    featureName: 'behaviourObservations',
    rightButtonText: 'Why Certificate Tracking Software?',
    rightButtonSrc: 'https://www.youtube.com/watch?v=xE2yXvWB038',
    mockupImg: '/features/action-items/action-items-banner.png'
  }

  const seo = {
    title: 'Workhub | Free Action Item Management Software',
    description: "Our free online Safety & Compliance software let's you create Action Items based on Incident Reporting, Forms, Inspections + more, so that you can deal with deficiences in your workplace.",
    image: '/features/action-items/social-card.jpg',
    // pathname,
    // article
  }

  const featureIndex = [
    {
      title: "Assign",
      para: "Identify deficiencies and corrective actions and assign them to workers. ",
    },
    {
      title: "Notify",
      para: "The system notifies workers that they have been assigned an Action Item via SMS or email.",
    },
    {
      title: "Corrective Actions",
      para: "Workers attach photos and documents, add comments, and select statuses to ultimately complete Action Items.",
    },
    {
      title: "Verify",
      para: "Administrators verify that Action items are completed properly and sign-off once they are complete. ",
    },

  ]


  return (
    <Layout {...lightboxProps}>
      <SEO {...seo} {...data.site} />
      <Banner {...bannerProps} {...lightboxProps} />
      <main className="feature-main">

        <section className="feature-section">
          <div className="container" >
            <div className="row switch-children">

              <div className="col-lg-6 feature-img">

                <ReactWOW animation="fadeInLeft" delay="0.9s">
                  <img
                    className="feature-img-right"
                    src="\features\action-items\action-items-cartoon.png"
                    alt="Action Items Cartoon"
                  /></ReactWOW>

              </div>


              <div className="col-lg-6 feature-text">
                <h2>Identifying deficiencies</h2>
                <p>
                  As your workers submit their inspections incident reports, safety meetings, and forms, deficiencies will invariably be found. Administrators (and workers with permission) can then create Action Items, tasks assigned to specific individual identifying problems - “Washer fluid low” - and indicating the necessary corrective actions - “Refill washer fluid”. For each action item created, an assignee can be chosen, a due date can be set, and a priority can be listed. Related documents can be included, such as photos or PDFs, to add context or detail. The creator can then optionally choose to notify the assignee by email, text, both, or neither. Regardless of the choice, the action item will then appear in the assignee’s required items. Reminders are provided as the action item ages, progressing from To Do to Coming Due and eventually to Past Due or Completed.
                </p>
              </div>
            </div>
          </div>
        </section>


        <section className="feature-section">
          <div className="container" >
            <div className="row">


              <div className="col-lg-6 feature-text">
                <h2>Taking corrective action</h2>
                <p>
                  Assignees will see action items assigned to them from their Worker dashboard. They can read through the deficiencies and recommended corrective action, review any attached documentation or imagery, and verify the due date. As they work through the needed action, they can add comments to track their progress and ultimately mark the action item as complete. If the assignee isn’t able to complete the task, action items can be reassigned to others to ensure nothing gets left undone. Any and all changes to an action item are tracked in the activity feed.
                </p>
              </div>

              <div className="col-lg-6 feature-img">

                <ReactWOW animation="fadeInRight" delay="0.9s">

                  <img
                    className="feature-img-left"
                    src="\features\action-items\action-items-computer.png"
                    alt="Action Items Computer View"
                  />

                </ReactWOW>

              </div>

            </div>
          </div>
        </section>

        <section className="feature-section">
          <div className="container" >
            <div className="row switch-children">

              <div className="col-lg-6 feature-img">

                <ReactWOW animation="fadeInLeft" delay="0.9s">
                  <img
                    className="feature-img-right"
                    src="\features\action-items\action-items-tablet.png"
                    alt="Action Items Tablet View"
                  /></ReactWOW>

              </div>


              <div className="col-lg-6 feature-text">
                <h2>Signing off on completion</h2>
                <p>
                  Once complete, each action item needs to signed off by an administrator. The system keeps a nice log of all action item at all stages of their lifecycle. The objective? To see every deficiency corrected and signed off, making your workplace safer. It also doesn’t hurt that you or your auditor can navigate back to the source document for each action item in the list.
                </p>
              </div>
            </div>
          </div>
        </section>

          {/* FEATURE OVERVIEW */}

  <section className="feature-overview-container">
          <h2>Overview</h2>

          <div className="feature-overview-grid">
            {featureIndex.map(item => (
              <FeatureCards title={item.title} para={item.para} />
            ))}
          </div>
        </section>

      </main>


    </Layout>
  )
}